import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_M2M_URL, TRANSACTION_STATUS_POLL_INTERVAL } from "../constants"
import { IGetSbpIncomeTransferRequestResponse } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function fetchM2MIncoming(
  token: string | null,
  incomeTransferRequestId: string | null | undefined,
) {
  const response = await axios(`${API_M2M_URL}/in/${incomeTransferRequestId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка загрузки данных")
  }
  return response.data
}

export const useGetSbpIncomeTransferRequest = (
  incomeTransferRequestId: string | null | undefined,
) => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IGetSbpIncomeTransferRequestResponse>({
    queryKey: ["incoming-m2m", incomeTransferRequestId],
    queryFn: () => fetchM2MIncoming(token, incomeTransferRequestId),
    refetchInterval: TRANSACTION_STATUS_POLL_INTERVAL,
    enabled: Boolean(token) && !!incomeTransferRequestId,
  })
}
